// @ts-ignore
import templateHTML from './remove-account.template.html';

/**
 * @param {import("core-services/provider-accounts.service").ProviderAccountsService} ProviderAccountsService
 * @param {import('stackdriver-errors-js').default['report']} $errorReporter
 */
export function RemoveAccountService(ProviderAccountsService, $uibModal, $errorReporter) {

  /**
   * @param {Pick<import("types/index").ProviderAccountViewModel.AccountViewModel, 'id' | 'accountName'>} account
   */
  this.removeAccountWithPrompt = function(account) {
    return $uibModal.open({
      template: templateHTML,
      controllerAs: 'ctrl',
      controller: ['$uibModalInstance', function($uibModalInstance) {
        // Ideally, this code would be pulled out somewhere else.
        //
        var self = this;

        self.state = "prompt";
        self.progress = 10;
        self.accountId = account.id;
        self.accountName = account.accountName;

        self.cancel = function () {
          $uibModalInstance.close('cancel');
        };

        self.close = function () {
          $uibModalInstance.close();
        };

        /**
         * Starts the removal process
         */
        self.handleRemoveAccountClicked = function () {
          _startProgress();

          return ProviderAccountsService
            .removeAccount(account.id)
            .then( _handleResponse )
            .catch( _handleFailure );
        };

        function _handleResponse(result) {
          if (result.status == "ok") {
            return _handleSuccess(account.id);
          } else {
            return Promise.reject(new Error("Unexpected error."));
          }
        }

        function _startProgress() {
          self.state = "removing";
        }

        function _handleSuccess(_account) {
          self.state = "removed";
        }

        function _handleFailure(response) {
          self.state = "error";
          $errorReporter(response);
        }

      }]
    }).result;
  }; /* removeAccountWithPrompt */
}

export default [
  'ProviderAccountsService',
  '$uibModal',
  '$errorReporter',
  RemoveAccountService,
];